import {CRYSTALS} from "../constants/crystals";
import {PRIMARY_COLOR} from "../styles/constants";

/**
 * Наборы кристаллов в магазине. priceRub — цена в рублях, она же на плашке
 * товара и в модалке (см. ShopCrystalsItem, CrystalsInfoModal).
 *
 * Удельная цена у первых четырех наборов одинаковая — CRYSTAL_PRICE_RUB за
 * кристалл; выгоден только самый большой набор, и его выгода показывается
 * бейджем скидки, как у сундуков.
 *
 * Покупка пока не подключена: попытка купить открывает модалку раннего
 * доступа с разовой наградой (см. configs/purchaseInterestRewards.js)
 */

// Базовая удельная цена: 19 ₽ за 100 кристаллов
export const CRYSTAL_PRICE_RUB = 0.19;

// Приветственный баланс новичка. Начисляет сервер (resolveWelcomeBalance в
// server/index.js), решение принимается один раз (welcomeBalanceResolvedAt).
// Правила у валют разные:
//  - нумены получает КАЖДЫЙ новый игрок;
//  - кристаллы — только зарегистрированные без реферальной привязки
//    (партнерской или дружеской): рефералам кристаллы и так выдаются
//    наградами рефералки.
// Нумены живут тут же, а не в отдельном конфиге: это одно решение об одном
// приветственном балансе, и суммы должны меняться вместе
export const NEW_PLAYER_WELCOME_CRYSTALS = 1000;
export const NEW_PLAYER_WELCOME_NUMENS = 5000;

export const CRYSTALS_CONFIGS = [{
  id: CRYSTALS.AMOUNT_100,
  crystals: 100,
  priceRub: 19,
}, {
  id: CRYSTALS.AMOUNT_300,
  crystals: 300,
  priceRub: 57,
}, {
  id: CRYSTALS.AMOUNT_500,
  crystals: 500,
  priceRub: 95,
}, {
  id: CRYSTALS.AMOUNT_1000,
  crystals: 1000,
  priceRub: 190,
}, {
  id: CRYSTALS.AMOUNT_5000,
  crystals: 5000,
  // 949 ₽ по базовой цене — округленная до 849 ₽ выгода и есть скидка
  priceRub: 849,
  discountPercents: 10,
  backgroundColor: PRIMARY_COLOR,
}]
